import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SetupBlackboxDialogContentComponent } from './setup-blackbox-dialog-content/setup-blackbox-dialog-content.component';

@Component({
  selector: 'app-setup-blackbox-dialog',
  template: ''
})
export class SetupBlackboxDialogComponent implements OnInit, OnDestroy {
  
  private modal: NgbModalRef | null = null
  private params: Params

  constructor(
    public modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.params = this.activatedRoute.snapshot.params
  }
  
  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }

    this.modal = this.modalService.open(
      SetupBlackboxDialogContentComponent,
      { centered: true, backdrop: 'static', size: 'lg' }
    )

    if (this.params.key) {
      this.modal.componentInstance.blackboxSerialNumber = this.params.key
    }

    this.modal.result.then((result) => {
      this.router.navigate(['/blackboxes'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['/blackboxes'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
